export interface DebugErrorEntry {
  timestamp: string;
  message: string;
  details?: string;
}

const MAX_ENTRIES = 50;
const errors: DebugErrorEntry[] = [];

export function pushDebugError(message: string, details?: string): void {
  errors.unshift({
    timestamp: new Date().toISOString(),
    message,
    details,
  });
  if (errors.length > MAX_ENTRIES) errors.length = MAX_ENTRIES;
}

export function getDebugErrors(): DebugErrorEntry[] {
  return errors;
}

export function clearDebugErrors(): void {
  errors.length = 0;
}
